export const extensionRoutes = [  {
    path: 'extensions/banners',
    loadChildren: () => import('./extensions/channel-banner/banner.module').then(m => m.BannerModule),
  },
  {
    path: 'extensions/social',
    loadChildren: () => import('./extensions/webhook/webhook.module').then(m => m.WebhookModule),
  }];
